import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTopDefault() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // change to "smooth" if you want animation
    });
  }, [pathname]);

  return null;
}
